import "core-js/modules/es.array.fill.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_2 = {
  "clip-path": "url(#clip0_390_388)"
};
var _hoisted_3 = ["fill"];

var _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_390_388"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "22.69",
  height: "25",
  fill: "white",
  transform: "translate(10.667 9.33337)"
})])], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M31.037 9.96338C31.0198 9.79182 30.9398 9.63267 30.8125 9.51641C30.6852 9.40015 30.5194 9.33498 30.347 9.33338H13.667C13.4939 9.33272 13.3269 9.39713 13.1991 9.51382C13.0713 9.63051 12.992 9.79097 12.977 9.96338L10.667 33.5734C10.6583 33.6694 10.6698 33.7662 10.7008 33.8575C10.7318 33.9487 10.7816 34.0325 10.847 34.1034C10.9108 34.1757 10.9893 34.2336 11.0772 34.2733C11.1652 34.3129 11.2605 34.3334 11.357 34.3334H32.667C32.7649 34.3336 32.8618 34.3132 32.9514 34.2736C33.041 34.2339 33.1212 34.176 33.187 34.1034C33.2511 34.032 33.2994 33.9479 33.3287 33.8566C33.358 33.7652 33.3676 33.6687 33.357 33.5734L31.037 9.96338ZM30.417 17.8934H26.027L25.747 10.7234H29.747L30.417 17.8934ZM18.737 10.7234H24.357L24.947 25.7734H18.147L18.737 10.7234ZM18.097 27.1534H24.997L25.227 32.9434H17.867L18.097 27.1534ZM17.347 10.7234L17.197 14.5934H13.927L14.307 10.7234H17.347ZM13.787 15.9834H17.137L16.477 32.9834H12.127L13.787 15.9834ZM26.667 32.9434L26.087 19.3334H30.557L31.887 32.9934L26.667 32.9434Z",
    fill: $props.fill
  }, null, 8, _hoisted_3)]), _hoisted_4]);
}